/**
 * Messages FR pour la gestion de FullCalendar
 */

module.exports = {

    day: 'Jour',
    month: 'Mois',
    week: 'Semaine',
    today: 'Aujourd\'hui',

    weekShort: 'S',

    countEvents: 'Pas d\'événement | 1 événement de plus | { count } événements de plus'

};
